<template>
    <div class="card">
        <div class="bg-blue-light p-1">
            <TitleButton 
                :showBtn="false"
                title="Payslip"
                :btnTitle="'Add New'"
                :showAddNew="false"
            />
        </div>
        <div class="my-2 px-2">
            <DateQuerySetter
                btnTitle="Go"
                @onClickGo="onClickToGo"
                class="tds-vds-query-setter"
            >
            </DateQuerySetter>
        </div>

        <div class="col-12 px-2 mt-2 mb-4">
          <div class="card p-2" style="min-height: 200px">
            <div class="table-responsive">
              <table class="table table-bordered">
                <thead>
                <tr>
                  <th class="text-left">Employee Name</th>
                  <th class="text-center">Employee Id</th>
                  <th class="text-center">Department</th>
                  <th class="text-center">Designation</th>
                  <th class="text-center">Payroll Period</th>
                  <th class="text-center">Total Earning</th>
                  <th class="text-center">Total Deduction</th>
                  <th class="text-center">Net Payable</th>
                  <th class="text-center">Action</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="(item, i) in tableItems" :key="i">
                  <td class="text-left">{{ item.name }}</td>
                  <td class="text-right">{{ item.serial_no }}</td>
                  <td class="text-right">{{ item.department_name }}</td>
                  <td class="text-right">{{ item.designation_name }}</td>
                  <td>{{ item.payroll_start_date }} to {{ item.payroll_end_date }}</td>
                  <td class="text-right">{{ item.total_earning }}</td>
                  <td class="text-right">{{ item.total_deduction }}</td>
                  <td class="text-right">{{ item.total }}</td>
                  <td>
                    <button class="btn btn-secondary btn-sm me-1"
                            @click="goToPrint(item)"
                            style="cursor: pointer"
                    >
                      <i class="fas fa-print"></i>
                    </button>
                  </td>
                </tr>
                </tbody>
              </table>
              <p v-if="tableItems.length < 0" class="text-center mt-5">No data</p>
            </div>
        </div>
        </div>

        <Loader v-if="loading"/>

    </div>
</template>

<script setup>
import TitleButton from '@/components/atom/TitleButton';
import {inject, onMounted, reactive, ref} from 'vue';
import { useStore } from 'vuex';
import { useRoute, useRouter } from 'vue-router';
import Loader from '@/components/atom/LoaderComponent'
import DateQuerySetter from '@/components/atom/DateQuerySetter.vue';
import handleHrPayroll from "@/services/modules/hrPayroll/hrPayroll";
import { computed } from 'vue';
import handleContact from '@/services/modules/contact'
import handleCompany from "@/services/modules/company";
import payslipPdf from '@/services/utils/pdf/payslipPdf';

const store = useStore();
const route = useRoute();
const router = useRouter();
const showError = inject('showError');
const showSuccess = inject('showSuccess');
const loading = ref(false)
const finalSettlement = ref(false)
const contactProfileId = ref('');
let contacts = ref([])
const tableItems = ref([]);
const params = ref({
    offset: 30,
});
let companyInfo = reactive({})
let payHeads = ref([])
let payrollStatement = ref({})
let payrollStatementData = ref({})
let payrollStatementSummary = ref({})
let payrollAdvice = ref([])
const { exportToPDF } = payslipPdf();
const { fetchCompanyInfo } = handleCompany();
const token = computed(() => localStorage.getItem('token'));

const {
  fetchPaySlipData,
  fetchSinglePaySlipData
} = handleHrPayroll()
const { fetchContactProfiles } = handleContact()

const onClickToGo = () => {
   getPaySlipData();
}

const goToPrint = async (item) => {
  let query = `?company_id=${route.params.companyId}`;
  query += `&contact_profile_id=${item.contact_profile_id}`

  await fetchSinglePaySlipData(item.payroll_statement_id, query).then((res) => {
    if (!res.status) {
      return
    }
    let data = res.data;
    payHeads.value = data.pay_head;
    payrollStatement.value = data.statement;
    payrollStatementData.value = data.data;
    payrollStatementSummary.value = data.summary;
    payrollAdvice.value = data.payroll_advice;
    finalSettlement.value = data.final_settlement;
  }).then(() => {
    exportToPDF(companyInfo, payHeads.value, payrollStatement.value, payrollStatementData.value, payrollStatementSummary.value, payrollAdvice.value, finalSettlement.value)
  }).catch((err) => {
    console.log("Something went wrong");
  });
}

const setCompanyInfo = async () => {
  await fetchCompanyInfo(route.params.companyId).then((res) => {
    companyInfo = res.data;
  }).catch((error) => {
    console.log(error);
  });
}

const getPaySlipData = async () => {
    const query = getQuery();
    loading.value = true
    tableItems.value = []

    await fetchPaySlipData(query).then(res => {
        if (!res.status){
            showError(res.message)
            return
        }

        tableItems.value = res.data;
    }).catch(err => {
        console.log(err)
    }).finally(() => {
        loading.value = false
    })
}

const getQuery = () => {
    let query = `?company_id=${route.params.companyId}&is_my_payslip=true`;
    if (route.query.page) query += '&page=' + route.query.page;
    if (route.query.start) query += '&start_date=' + route.query.start;
    if (route.query.end) query += '&end_date=' + route.query.end;
    query += '&offset=' + params.value.offset
    return query;
}

onMounted(() => {
  Promise.all([
    setCompanyInfo(),
  ])
})
</script>
